import { io } from "socket.io-client";
import { socketApiUrl } from "./axiosProvider";
import { getCookie } from "../context/useCookies";

let socket = null;

const initializeSocket = () => {
  const token = getCookie("accessToken")?.replace(/^"|"$/g, "");

  if (token) {
    socket = io(socketApiUrl, {
      auth: {
        token: `Bearer ${token}`,
      },
      autoConnect: false,
    });
  } else {
    console.warn("No token found for socket auth");
  }
};

export const reconnectSocket = () => {
  if (socket) {
    socket.disconnect();
  }
  initializeSocket();
  socket && socket.connect();
};

export const socketConnection = () => {
  if (!socket) {
    initializeSocket();
  }
  if (socket && !socket.connected) {
    socket.connect();
  }
  return socket;
};

export const joinTicketRoom = (ticketId) => {
  const sock = socketConnection();
  if (sock && ticketId) {
    sock.emit("join-ticket-room", { ticketId });
  }
};

export const leaveTicketRoom = (ticketId) => {
  const sock = socketConnection();
  if (sock && ticketId) {
    sock.emit("leave-ticket-room", { ticketId });
  }
};

export const sendTicketMessage = (messageData) => {
  const sock = socketConnection();
  if (sock) {
    sock.emit("new-ticket-message", messageData);
  }
};

export const emitTyping = (ticketId, userId) => {
  const sock = socketConnection();
  if (sock) {
    sock.emit("typing", { ticketId, userId });
  }
};

export const emitStopTyping = (ticketId, userId) => {
  const sock = socketConnection();
  if (sock) {
    sock.emit("stop-typing", { ticketId, userId });
  }
};

export const isSocketConnected = () => {
  return socket && socket.connected;
};

export const getSocketId = () => {
  return socket ? socket.id : null;
};

export const addSocketListener = (event, callback) => {
  const sock = socketConnection();
  if (sock) {
    sock.on(event, callback);
  }
};

export const removeSocketListener = (event, callback) => {
  if (socket) {
    if (callback) {
      socket.off(event, callback);
    } else {
      socket.off(event);
    }
  }
};

export const cleanupSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
};
